export default __webpack_public_path__ + "static/media/search.edbcf7d0.svg";